// import React from "react";
// import { Spin } from "antd"; // Removed unused Button import

// // Reusable Spinner component
// const Spinner = ({ loading }) => {
//   return (
//     <>
//       {loading && (
//         <div
//           style={{
//             position: "fixed",
//             top: 0,
//             left: 0,
//             width: "100vw",
//             height: "100vh",
//             backgroundColor: "rgba(255, 255, 255, 0.36)", // Transparent background
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             zIndex: 1000, // Ensure it appears above other elements
//           }}
//         >
//           <Spin size="large" />
//         </div>
//       )}
//     </>
//   );
// };

// export default Spinner;

import React from "react";
import { CircularProgress, Box } from "@mui/material";

const Spinner = ({ loading }) => {
  if (!loading) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        bgcolor: "rgba(108, 108, 108, 0.36)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1300, // slightly higher than 1000 to match MUI layers
      }}
    >
      <CircularProgress size={60} />
    </Box>
  );
};

export default Spinner;
